import React from 'react';
import { Box, PageHeading } from '@99designs/emu';
import { Layout } from '../Layout';
import { TermsUpdate } from '../TermsUpdate';
import { VerifyLoginForm } from './VerifyLoginForm';
import { useTwoFactorUI } from './hooks';

export function VerifyLogin({ onAuthSuccess }: { onAuthSuccess: (target: string) => void }) {
    const {
        resendRequestCount,
        resendToken,
        verifyToken,
        uiState,
        error,
        showUpdatedTerms,
        postLoginUrl,
    } = useTwoFactorUI(onAuthSuccess);

    if (showUpdatedTerms) {
        return <TermsUpdate redirectUrl={postLoginUrl} onTermsAcceptance={onAuthSuccess} />;
    }

    return (
        <Layout title={__('Authenticate')}>
            <Box>
                <Box
                    display="flex"
                    flexDirection="row"
                    alignItems="baseline"
                    justifyContent="stretch"
                    marginTop="1bu"
                    marginBottom="1bu"
                >
                    <PageHeading withDivider>
                        {__("We've emailed you a temporary login code to confirm it's really you")}
                    </PageHeading>
                </Box>
                <Box marginBottom="1bu" marginTop="1bu">
                    {__(
                        "You're almost there. This helps us to keep your account as secure as possible"
                    )}
                </Box>

                <VerifyLoginForm
                    inputError={error}
                    onSubmit={verifyToken}
                    requestNewToken={resendToken}
                    resendRequestCount={resendRequestCount}
                    uiState={uiState}
                />
            </Box>
        </Layout>
    );
}
